/** Default per-number cap (in currency units). */
export const DEFAULT_PER_NUMBER_CAP = 5000;

/** Quick stake options exposed in NewPlay UI (in currency units). */
export const QUICK_STAKES = [25, 50, 100, 200, 500] as const;

/** Play types available in the system. */
export const PLAY_TYPES = ['fijo', 'corrido', 'parle', 'centena'] as const;
export type PlayType = typeof PLAY_TYPES[number];

/** Number length requirements by play type. */
export const NUMBER_LENGTH: Record<PlayType, number> = {
  fijo: 2,
  corrido: 2,
  parle: 2,
  centena: 3,
};
